import request from '@/utils/request'

// Delivery List By Period
export function epms5030List(param) {
    let data = param
    return request({
        url: `/delivery/epms5030/epms5030List`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}